import React, { Fragment } from 'react';
import BrowserFilter from 'components/BrowserFilter/BrowserFilter.react';
import BrowserMenu from 'components/BrowserMenu/BrowserMenu.react';
import MenuItem from 'components/BrowserMenu/MenuItem.react';
import SecurityDialog from 'dashboard/Data/Browser/SecurityDialog.react';
import BrowserToolbarButton from 'components/BrowserToolbarButton/BrowserToolbarButton.react';
import Separator from 'components/BrowserMenu/Separator.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import styles from './Browser.scss';

const BrowserToolbar = ({
  data,
  className,
  classNameForPermissionsEditor,
  count,
  perms,
  schema,
  userPointers,
  filters,
  selection,
  relation,
  setCurrent,
  onFilterChange,
  onAddColumn,
  onAddRow,
  onAddClass,
  onAttachRows,
  onAttachSelectedRows,
  onExport,
  onRemoveColumn,
  onDeleteRows,
  onDropClass,
  onChangeCLP,
  onRefresh,
  isRefreshing,
  hidePerms,

  enableDeleteAllRows,
  enableExportClass,
  enableSecurityDialog,
}) => {
  const selectionLength = Object.keys(selection).length;
  const details = [];
  const subdetails = [];
  if (count !== undefined) {
    let filtersSize = '';
    if (data) {
      filtersSize = `Show ${data.length} from `;
    }


    if (count === 1) {
      details.push(`${filtersSize}1 object`);
    } else {
      details.push(`${filtersSize + count} objects`);
    }
  }

  if (!relation) {
    if (perms && !hidePerms) {
      const read = perms.get && perms.find && perms.get['*'] && perms.find['*'];
      const write = perms.create && perms.update && perms.delete && perms.create['*'] && perms.update['*'] && perms.delete['*'];
      if (read && write) {
        subdetails.push('Public Read and Write enabled');
      } else if (read) {
        subdetails.push('Public Read enabled');
      } else if (write) {
        subdetails.push('Public Write enabled');
      }
    }
  }


  let menu = null;
  if (relation) {
    menu = (
      <BrowserMenu title="Edit" icon="icon-cog">
        <MenuItem
          text={`Create ${relation.targetClassName} and attach`}
          onClick={onAddRow} />
        <MenuItem
          text="Attach existing row"
          onClick={onAttachRows} />
        <Separator />
        <MenuItem
          disabled={selectionLength === 0}
          text={selectionLength === 1 && !selection['*'] ? 'Detach this row' : 'Detach these rows'}
          onClick={() => onDeleteRows(selection)} />
      </BrowserMenu>
    );
  } else {
    menu = (
      <BrowserMenu title="Edit" icon="icon-cog">
        <MenuItem text="Add a row" onClick={onAddRow} />
        <MenuItem text="Add a column" onClick={onAddColumn} />
        <MenuItem text="Add a class" onClick={onAddClass} />
        <Separator />
        <MenuItem
          disabled={!selectionLength}
          text={`Attach ${selectionLength <= 1 ? 'this row' : 'these rows'} to relation`}
          onClick={onAttachSelectedRows} />
        <Separator />
        <MenuItem
          disabled={selectionLength === 0}
          text={selectionLength === 1 && !selection['*'] ? 'Delete this row' : 'Delete these rows'}
          onClick={() => onDeleteRows(selection)} />
        <MenuItem text="Delete a column" onClick={onRemoveColumn} />
        {enableDeleteAllRows ? <MenuItem text="Delete all rows" onClick={() => onDeleteRows({ '*': true })} /> : <noscript />}
        <MenuItem text="Delete this class" onClick={onDropClass} />
        {enableExportClass ? <Separator /> : <noscript />}
        {enableExportClass ? <MenuItem text="Export this data" onClick={onExport} /> : <noscript />}
      </BrowserMenu>
    );
  }

  let subsection = className;
  if (relation) {
    subsection = `'${relation.key}' on ${relation.parent.id}`;
  } else if (subsection.length > 30) {
    subsection = `${subsection.substr(0, 30)}\u2026`;
  }

  return (
    <Toolbar
      relation={relation}
      filters={filters}
      section={relation ? `Relation <${relation.targetClassName}>` : 'Class'}
      subsection={subsection}
      details={details.join(' \u2022 ')}
      subdetails={subdetails}>
      <div className={[styles.toolbar, data ? styles.show : null].join(' ')}>
        <BrowserToolbarButton icon="plus-solid" name="Add a new Row" onClick={onAddRow} />

        <BrowserToolbarButton icon="refresh-solid" name="Refresh" onClick={onRefresh} />

        <BrowserFilter
          setCurrent={setCurrent}
          schema={schema}
          filters={filters}
          onChange={onFilterChange} />

        {enableSecurityDialog ? <SecurityDialog
          setCurrent={setCurrent}
          disabled={!!relation}
          perms={perms}
          className={classNameForPermissionsEditor}
          onChangeCLP={onChangeCLP}
          userPointers={userPointers} /> : <noscript />}
        {menu}
      </div>
    </Toolbar>
  );
};

export default BrowserToolbar;
